import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Inbox, ListTodo, FolderOpen } from "lucide-react";

export type MyWorkTab = "todo" | "triage" | "active";

interface Props {
  active: MyWorkTab;
  onChange: (tab: MyWorkTab) => void;
  counts: { todo: number; triage: number; active: number };
}

const LABELS = {
  en: { todo: "My To-Do", triage: "Triage", active: "Active Deals" },
  fr: { todo: "Ma To-Do", triage: "À Trier", active: "Dossiers Actifs" },
};

const TABS: { key: MyWorkTab; icon: React.ElementType }[] = [
  { key: "todo", icon: ListTodo },
  { key: "triage", icon: Inbox },
  { key: "active", icon: FolderOpen },
];

export const MyWorkTabs: React.FC<Props> = ({ active, onChange, counts }) => {
  const { language } = useLanguage();
  const labels = LABELS[language] || LABELS.en;

  return (
    <div className="flex gap-2 border-b border-white/10">
      {TABS.map(({ key, icon: Icon }) => {
        const isActive = active === key;
        const count = counts[key];
        return (
          <button
            key={key}
            onClick={() => onChange(key)}
            className={`flex items-center gap-2 px-4 py-3 text-sm font-medium transition-all border-b-2 -mb-px ${
              isActive
                ? "border-amber-400 text-white"
                : "border-transparent text-gray-400 hover:text-gray-200"
            }`}
          >
            <Icon className="w-4 h-4" />
            <span>{labels[key]}</span>
            {count > 0 && (
              <span
                className={`px-2 py-0.5 text-xs rounded-full ${
                  key === "triage"
                    ? "bg-red-500/20 text-red-300"
                    : "bg-white/10 text-gray-300"
                }`}
              >
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};
